<template>
    <div class="content ht-100v pd-0">
        <!-- <iframe :src="`https://192.168.1.115:8081?access_token=${$store.state.user.token}`" class="rpt-frame"></iframe> -->
        <!-- <iframe :src="`https://surgalt.gazar.gov.mn/reportv5?access_token=${$store.state.user.token}`" class="rpt-frame"></iframe> -->
        <iframe :src="`https://academy-reportv5.gosmart.mn/reportv5?access_token=${$store.state.user.token}`" class="rpt-frame"></iframe>
    </div>
</template>

<script>
export default {
    name: 'V5Report'
}
</script>

<style scoped>
.rpt-frame {
  border: none;
  width: 100%;
  height: 100vh;
}

iframe.rpt-frame .trv-content,
.rpt-frame .trv-nav {
  border: none !important;
}
</style>